"use client";

import { Box, Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { Button, Heading, Text } from "@/components/ui";
import { PageTypeGlobal } from "@/lib/types";

export default function PublicRouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Public route error:", error);
  }, [error]);

  return (
    <Flex
      px={{ base: 4, lg: 8 }}
      py={{ base: 10, md: 14 }}
      minH="50vh"
      align="center"
      justify="center"
    >
      <Box maxW="480px" textAlign="center">
        <Heading size="lg" fontWeight="600" mb={3}>
          Something went wrong
        </Heading>
        <Text variant="secondary" fontSize="sm" lineHeight="1.6" mb={6}>
          This page could not be loaded. Try again, or browse classes.
        </Text>
        <Flex gap={3} justify="center" wrap="wrap">
          <Button variant="primary" size="sm" onClick={() => reset()}>
            Try again
          </Button>
          <Button
            as="a"
            href={PageTypeGlobal.Classes}
            variant="outline"
            size="sm"
          >
            Browse classes
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}
